import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'
import Scroll from '../services/Scroll'
import SectionObserver from './SectionObserver'

export default class LpSectionCardNav extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            links: [],
            images: [],
            sectionObserver: null,
        }

        this.state = null
    }

    prepare() {
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize-x', this.handleResize)

        if (this.ref.sectionObserver) {
            this.sectionObserver = new SectionObserver(this.ref.sectionObserver, {
                shouldCalculateLastActiveSection: true,
                query: this.options.sectionObserver?.query,
            })
            this.sectionObserver.prepare()

            EventBus.on(
                EVENTS.SECTIONOBSERVER_SECTIONCHANGE,
                this.handleSectionObserverSectionChange,
            )
            this.sectionObserver.update()
        } else {
            this.select(0)
        }

        this.resize()
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize-x', this.handleResize)

        if (this.sectionObserver) {
            this.sectionObserver.destroy()
            EventBus.off(
                EVENTS.SECTIONOBSERVER_SECTIONCHANGE,
                this.handleSectionObserverSectionChange,
            )
        }
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = () => {
        this.update()
    }

    handleSectionObserverSectionChange = (event) => {
        const sectionsInViewport = event.sectionsInViewport
        if (sectionsInViewport.length == 0) {
            this.select(0)
        } else {
            const mostVisibleSection = sectionsInViewport[0]
            this.select(this.findLinkIndexById(mostVisibleSection.element.id))
        }
    }

    resize() {
        const scrollY = Scroll.getScroll().y

        const targetStartRect = document
            .querySelector(this.options.queryStart)
            ?.getBoundingClientRect()
        const targetEndRect = document.querySelector(this.options.queryEnd)?.getBoundingClientRect()

        this.state = {
            targetStart: {
                documentTop: scrollY + targetStartRect.top,
            },
            targetEnd: {
                documentEnd: scrollY + targetEndRect.height + targetEndRect.top,
            },
        }

        this.update()
    }

    update() {
        const scrollY = Scroll.getScroll().y

        if (!this.state) {
            return
        }

        if (
            scrollY > this.state.targetStart.documentTop &&
            scrollY < this.state.targetEnd.documentEnd - Scroll.getScroll().window.height
        ) {
            this.element.classList.add('is-active')
        } else {
            this.element.classList.remove('is-active')
        }
    }

    select(index) {
        if (this.index === index) {
            return
        }

        this.ref.links.forEach((link, _index) => {
            link.classList.toggle('is-active', index === _index)
        })

        this.ref.images.forEach((image, _index) => {
            image.classList.toggle('is-active', index === _index)
        })

        this.index = index
    }

    findLinkIndexById(id) {
        return this.ref.links.findIndex((link) => link.href.split('#')[1] === id)
    }
}
